/* No discount codes on the storefront: any /discount/CODE?redirect=/x link becomes a plain /x link (the code is kept in data-gb-code for our COD form).
   Bundle discounts come from the COD form + Worker (and Bundlex in the cart).
   Also injects small layout fixes (category title, floating buttons, empty lightbox src) and puts the current product into the WhatsApp message.
   The old <=375px pack "list" layout was removed: pack cards stay 3 columns on every phone (layout lives in snippets/gb-pdp-tiers.liquid). */
(function () {
  if (window.__gbNoCode) return; window.__gbNoCode = 1;
  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  try {
    var st = document.createElement('style'); st.id = 'gb-fixes';
    st.textContent = [
      '.gb-cat__t{word-break:normal!important;overflow-wrap:normal!important;hyphens:none!important;-webkit-hyphens:none!important}',
      '.gba:has(>figure:only-child){max-width:460px;margin-inline:auto}',
      '.gbwa{z-index:2147480000!important}',
      '.gbcc__fab,#gbccFab{z-index:77!important}',
      '@media (min-width:990px){',
      '.gbwa{right:26px!important;bottom:26px!important}',
      '.gbcc__fab,#gbccFab{right:26px!important;left:auto!important;bottom:100px!important}',
      '}',
      '@media (max-width:989px){',
      '.gbwa{bottom:calc(86px + env(safe-area-inset-bottom,0px))!important}',
      '.gbcc__fab,#gbccFab,html body:not(#gbm2) .gbcc__fab,html body:not(#gbm2) #gbccFab{bottom:calc(158px + env(safe-area-inset-bottom,0px))!important}',
      '.gbk__rb{font-weight:700!important}',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  function plain(h) {
    try {
      var u = new URL(h, location.origin);
      if (u.pathname.indexOf('/discount/') !== 0) return null;
      var r = u.searchParams.get('redirect');
      return r && r.charAt(0) === '/' ? r : '/cart';
    } catch (e) { return null; }
  }
  function fix(a) {
    var h = a.getAttribute('href'); if (!h) return; var p = plain(h); if (!p) return;
    try { var m = h.match(/\/discount\/([^?#]+)/); if (m && !a.getAttribute('data-gb-code')) a.setAttribute('data-gb-code', decodeURIComponent(m[1])); } catch (e) {}
    a.setAttribute('href', p);
  }
  function lb() { var i = document.querySelector('.gbr__lb img'); if (i && !i.getAttribute('src')) i.setAttribute('src', BLANK); }
  function scan(root) { (root || document).querySelectorAll('a[href*="/discount/"]').forEach(fix); lb(); }
  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); });
  document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="/discount/"]'); if (a) fix(a); }, true);
  if (window.MutationObserver) new MutationObserver(function (m) {
    m.forEach(function (x) {
      if (x.type === 'attributes') { if (x.target.tagName === 'A') fix(x.target); }
      else x.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'A') fix(n); else if (n.querySelectorAll) scan(n); } });
    });
    lb();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  /* WhatsApp: the message carries the product (or page) the customer is on */
  function waText() {
    var t = '';
    try {
      var og = document.querySelector('meta[property="og:title"]');
      var h1 = document.querySelector('h1');
      var name = ((h1 && h1.textContent) || (og && og.content) || document.title || '').replace(/\s+[–|\-]\s+Glambe.*$/i, '').replace(/\s+/g, ' ').trim();
      var c = document.querySelector('link[rel="canonical"]');
      var url = (c && c.href) || (location.origin + location.pathname);
      if (/^\/products\//.test(location.pathname) && name) t = 'Hi Glambe! I am interested in: ' + name + ' ' + url;
      else if (/^\/collections\//.test(location.pathname) && name) t = 'Hi Glambe! I need help choosing from: ' + name + ' ' + url;
      else t = 'Hi Glambe! I need help.';
    } catch (e) { t = 'Hi Glambe! I need help.'; }
    return t;
  }
  function isTrack(a) { return (a.href || '').toLowerCase().indexOf('track') > -1; }
  function wa(a) {
    if (isTrack(a)) return;
    try { var u = new URL(a.href); u.searchParams.set('text', waText()); a.setAttribute('href', u.toString()); } catch (e) {}
  }
  function waAll() { document.querySelectorAll('a[href*="wa.me/971563014113"]').forEach(wa); }
  document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="wa.me/971563014113"]'); if (a) wa(a); }, true);
  document.addEventListener('DOMContentLoaded', waAll); setTimeout(waAll, 1500);
})();
